import { render } from "./SettingsView.html?vue&type=template&id=911f2d7a&scoped=true&external"
import script from "./SettingsView.js?vue&type=script&lang=js&external"
export * from "./SettingsView.js?vue&type=script&lang=js&external"

import "./SettingsView.css?vue&type=style&index=0&id=911f2d7a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-911f2d7a"]])

export default __exports__